import React from 'react';
import { Typography, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
const { Paragraph } = Typography;
 

const Home: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mainTextArea'>

                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div className='mainTextHeader'>
                            <h4>{t('home.title')}</h4>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                        {/* Content */}  
                        <Paragraph>
                        {t('home.text_one')}
                        </Paragraph>

                        <Paragraph>
                        {t('home.text_two')}
                        </Paragraph>

                        <Paragraph>
                        {t('home.text_three')}
                        </Paragraph>

                        <Paragraph>
                        {t('home.text_four')}
                        </Paragraph>

                        {/* Placeholder for additional content */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="img_home_one" style={{ height: '192px', backgroundColor: '#CCC', borderRadius: '5px' }}>  
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="img_home_two" style={{ height: '192px', backgroundColor: '#CCC', borderRadius: '5px' }}></div>
                            </Col>
                            <Col span={8}>
                                <div className="img_home_three" style={{ height: '192px', backgroundColor: '#CCC', borderRadius: '5px' }}></div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Home;